export default "images/footer-bg.jpg"